import React, { useEffect, useState, useContext } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import cn from 'classnames'
import { CustomerContext } from '../../../contexts/CustomerContext'
import Option from '../../../models/Option'
import AttentionBanner from '../../attention-banner'
import Typography from '../../Typography'
import AppointmentOption from '../../appointment-option'
import Spinner from '../../Spinner'
import { routes } from '../../../routes'
import classes from './appointment-session-selection.module.sass'
import useQueryString from '../../../hooks/use-query-string'
import { Price } from '../../../models';

const AppointmentOptionSelection = () => {
  const { customer, setCustomer } = useContext(CustomerContext)
  const { packageId } = useParams()
  const { o: isOther } = useQueryString()
  const history = useHistory()
  const [options, setOptions] = useState([])
  const [numImgsLoaded, setNumImgsLoaded] = useState(0)

  const incrementImgsLoaded = () => setNumImgsLoaded((prev) => prev + 1)

  const optionsContainerClasses = cn({
    [classes.optionsContainer]: true,
  })

  useEffect(() => {
    const priceScope = Price.where({ hasPrice: true });

    Option
      .includes(['image_types', 'prices'])
      .order('abbreviation')
      .merge({ prices: priceScope })
      .where({ packageId, hasPurchasedPreviousOption: [(customer.email || '').toLowerCase(), packageId] })
      .all()
      .then((res) => {
        setOptions(res.data)
      })
  }, [packageId])

  const onSelect = (opt) => {
    const { currentOrderPackage } = customer

    currentOrderPackage.optionId = opt.id
    currentOrderPackage.apiOption = opt
    currentOrderPackage.option = opt

    setCustomer({ ...customer, currentOrderPackage })
    history.push(routes.appointmentSelection())
  }

  if (options.length === 0) {
    return (
      <div className={classes.spinnerContainer}>
        <Spinner color="blue" />
      </div>
    )
  }

  return (
    <>
      <div>
        <AttentionBanner content="Step 1. Choose Your Session" />
        <div className={classes.content}>
          {/*<Typography classes={classes.subtext} fontStyle="italic">*/}
          {/*  {isOther ? '' : 'Senior '}*/}
          {/*  Sessions include time with the photographer.*/}
          {/*  Portrait packages available separately.*/}
          {/*</Typography>*/}
          <div className={optionsContainerClasses}>
            {options.map((option, i) => (
              <AppointmentOption
                key={option.id}
                option={option}
                handleSelect={onSelect}
                i={i}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default AppointmentOptionSelection
